<ng-template #filterContainer></ng-template>